import React from 'react'

const EndSars = () => {

    return (
        <>
            <div className="cover">
                <div className="cover1"></div>
                <div className="container cover-text">
                    <h2>#End<span className='orange-text darken-3'>SARS</span></h2>
                    <h4>#End<span className='orange-text darken-3'>PoliceBrutality</span></h4>
                </div>
            </div>
        </>
    )
}

export default EndSars
